export default {
    title: '타자 배틀',
    common: {
        time: '{minutes}분 {seconds}초',
        kpmUnit: '{count}타',
        noKill: '처치한 적 없음',
        notEnoughStar: {
            title: '칭찬별이 부족해요',
            message: '타자 배틀을 시작하려면 칭찬별이 1개 필요해요.',
            confirm: '확인',
        },
    },
    index: {
        back: '뒤로',
        classroomTitle: '{school} {grade}학년 {class_name}',
        header: {
            name: '이름',
            phase: '페이즈/보스',
            accuracy: '정확도',
            time: '소요 시간',
            kpm: '타수',
            date: '기록 날짜',
        },
        meMark: '나',
        recentRecord: '최근 기록',
        myRanking: '내 랭킹보기',
        empty: '아직 기록이 없어요.',
        startRaid: '레이드 시작',
        startFailed: '레이드를 시작할 수 없어요.',
    },
    inplay: {
        phase: '페이즈 {phase}',
        exit: '나가기',
        combo: '콤보',
        transition: {
            phase: '페이즈',
            completed: '격파 성공!',
            awakening: '초 뒤 {phase}페이즈가 옵니다',
            loading: '불러오는 중...',
            skip: '건너뛰기',
        },
        nextLabel: '다음: {next}',
        inputLabel: '입력',
        leaveModal: {
            title: '지금 나갈까요?',
            message: '지금 나가면 현재까지의 기록으로 타자 배틀이 종료되어요.<br />그래도 나갈까요?',
            no: '아니오',
            yes: '네',
        },
        contentError: {
            title: '콘텐츠를 불러오지 못했어요',
            message: '잠시 후 다시 시도해 주세요.',
            confirm: '확인',
        },
    },
    result: {
        gameOver: '게임 오버',
        bestRecord: '최고 기록을 경신했어요! 로비로 돌아가서 랭킹을 확인해보세요.',
        reachedPhase: '도달 페이즈',
        defeatedBoss: '처치 몬스터',
        defeatedUnit: '마리',
        lastBoss: '마지막 보스',
        targetKpmTooltip: '{grade}학년 목표 타수: {targetKpm}타',
        ranking: '로비로 돌아가기',
        retry: '다시 시작하기',
        registered: {
            title: '반별 랭킹에 등록됐어요!',
            message: '페이즈가 높을수록, 페이즈가 같으면 정확도·타수가 높을수록 상위예요.',
        },
        stats: {
            maxCombo: '최대 콤보',
            accuracy: '정확도',
            typo: '오타',
            time: '소요 시간',
            kpm: '타수',
            comboUnit: '{count}콤보',
            accuracyUnit: '{count}%',
            typoUnit: '{count}회',
            kpmUnit: '{count}타',
        },
    },
};
